"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactRedux = require("react-redux");
var _commonI18n = require("@mmc/common-i18n");
var _text = require("@mmc/text");
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var CarSelectorPrice = function CarSelectorPrice(_ref) {
  var zeroMessage = _ref.zeroMessage,
    pricevalue = _ref.pricevalue,
    price = _ref.price,
    theme = _ref.theme,
    config = _ref.config,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData;
  var hasZeroMessage = typeof zeroMessage === 'string' && zeroMessage.length > 1;
  return /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "" + theme.bodyCopy
  }, price !== null && price !== undefined && price !== ' ' && (price > 0 || hasZeroMessage) && /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      value: price,
      currency: handleNestedProp(config, 'config.currencyFormat'),
      locale: handleNestedProp(config, 'config.localeCode'),
      displayValue: pricevalue,
      zeroMessage: zeroMessage
    },
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    disclaimerData: disclaimerData
  })));
};
CarSelectorPrice.defaultProps = {
  pricevalue: '',
  price: '',
  config: {}
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(CarSelectorPrice);
exports["default"] = _default;